// File: components/inspections/EditingSection.jsx
import { useState } from "react";
import { updateInspection } from "../../../services/api/qa/inspectionService";
import toast from "react-hot-toast";

function EditingSection({ inspectionData, onUpdate }) {
  const [actualValue, setActualValue] = useState(inspectionData.actual_value || "");
  const [remarks, setRemarks] = useState(inspectionData.remarks || "");
  const [inspectionDate, setInspectionDate] = useState(inspectionData.inspection_date || "");
  const [saving, setSaving] = useState(false);

  // Only editable if draft or rejected
  const canEdit = inspectionData.status === "draft" || inspectionData.status === "rejected";

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = {
        actual_value: actualValue,
        remarks,
        inspection_date: inspectionDate,
      };
      const response = await updateInspection(inspectionData.id, payload);
      if (response.data) {
        onUpdate(response.data); // update parent state
        toast.success("Inspection updated successfully!");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to save. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-4 border rounded-md bg-white shadow-sm">
      <h2 className="text-lg font-semibold mb-4">Edit Inspection</h2>

      {/* BOQ Item */}
      <div className="mb-3">
        <label className="block font-medium">BOQ Item:</label>
        <p>{inspectionData.boq_item.item_name} ({inspectionData.boq_item.description})</p>
      </div>

      {/* Checklist */}
      <div className="mb-3">
        <label className="block font-medium">Checklist:</label>
        <p>{inspectionData.checklist.name}</p>
      </div>

      {/* Inspection Date */}
      <div className="mb-3">
        <label className="block font-medium">Inspection Date:</label>
        {canEdit ? (
          <input
            type="date"
            value={inspectionDate}
            onChange={(e) => setInspectionDate(e.target.value)}
            className="border p-2 rounded w-full"
          />
        ) : (
          <p>{inspectionDate}</p>
        )}
      </div>

      {/* Actual Value */}
      <div className="mb-3">
        <label className="block font-medium">Actual Value:</label>
        {canEdit ? (
          <input
            type="text"
            value={actualValue}
            onChange={(e) => setActualValue(e.target.value)}
            className="border p-2 rounded w-full"
          />
        ) : (
          <p>{actualValue || "-"}</p>
        )}
      </div>

      {/* Remarks */}
      <div className="mb-3">
        <label className="block font-medium">Remarks:</label>
        {canEdit ? (
          <textarea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            className="border p-2 rounded w-full"
            rows={3}
          />
        ) : (
          <p>{remarks || "-"}</p>
        )}
      </div>

      {/* Save button */}
      {canEdit && (
        <div className="flex items-center space-x-2">
          <button
            onClick={handleSave}
            disabled={saving}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      )}

      {!canEdit && (
        <p className="text-gray-500 text-sm mt-2">
          This inspection cannot be edited as its status is "{inspectionData.status}".
        </p>
      )}
    </div>
  );
}

export default EditingSection;